module.exports = __webpack_public_path__ + "img/banner3_3_kr.b86d5063.png";